import * as THREE from '@phdsoft/three'
import { Util } from '@phdsoft/common';

export class PlaneUtil {

    normal: THREE.Vector3;
    point: THREE.Vector3;
    epsilon: number;
    constructor() {

    }

    public setFromNormalAndPoint(normal: THREE.Vector3, point: THREE.Vector3) {
        this.normal = normal;
        this.point = point;
        this.epsilon = 0.00005;
    }

    public setFromCoplanarPoints(pointA: THREE.Vector3, pointB: THREE.Vector3, pointC: THREE.Vector3) {
        const AB = pointB.clone().sub(pointA.clone());
        const AC = pointC.clone().sub(pointA.clone());
        AB.cross(AC);
        this.normal = AB;
        this.normal.normalize();
        this.point = pointA;
        this.epsilon = 0.00005;
    }

    private get A() {
        return this.normal.x;
    }

    private get B() {
        return this.normal.y;
    }

    private get C() {
        return this.normal.z;
    }

    private get D() {
        return -this.A * this.point.x - this.B * this.point.y - this.C * this.point.z;
    }

    public PointSignal(point: THREE.Vector3) {
        let signal = this.A * point.x + this.B * point.y + this.C * point.z + this.D;
        if (signal < this.epsilon)
            return -1;
        else if (signal > this.epsilon)
            return 1;
        return 0;
    }

    public IntersectLine(direction: THREE.Vector3, point: THREE.Vector3, intersectPoint: THREE.Vector3): THREE.Vector3 {
        intersectPoint = new THREE.Vector3();
        direction.normalize();

        const ortho = this.normal.clone().dot(direction.clone());

        if (Math.abs(ortho) <= this.epsilon) {
            return undefined;
        }
        else {
            const dot = this.normal.dot(point);
            const t = (-this.D - dot) / ortho;
            intersectPoint = point.add(direction.multiplyScalar(t));
            return intersectPoint;
        }
    }

    public NearestPoint(point: THREE.Vector3) {
        let intersectPoint = new THREE.Vector3();
        //this.IntersectLine(this.normal.clone(), point.clone(), intersectPoint);
        return this.IntersectLine(this.normal.clone(), point.clone(), intersectPoint);
    }

    public PointDistanceAndClosest(point: THREE.Vector3, closest: THREE.Vector3) {
        closest = this.NearestPoint(point.clone());
        if (Util.isNullOrUndefined(closest)) {
            return 10000;
        }
        const d = closest.sub(point);
        return d.length();
    }

    public PointDistance(point: THREE.Vector3) {
        let closest = new THREE.Vector3();
        return this.PointDistanceAndClosest(point.clone(), closest);
    }
}
